import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../applicationUi/components/Table";
import * as XLSX from "xlsx";
import { format } from "date-fns";
import { fetchRecallClientsReport } from "../../../../store/thunks/reportsThunk";

const RecallClientReport = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Fetch recall clients data from Redux state
  const {
    data: recallClients = [],
    loading,
    error,
  } = useSelector((state) => state.reports.recallClients) || {};

  useEffect(() => {
    dispatch(fetchRecallClientsReport());
  }, [dispatch]);

  const columns = [
    {
      header: "Client Name",
      accessor: "name",
    },
    {
      header: "Email",
      accessor: "email",
    },
    {
      header: "Phone",
      accessor: (row) => Array.isArray(row.phone) ? row.phone.join(", ") : "N/A",
    },
    {
      header: "Last Appointment",
      accessor: (row) =>
        row.lastAppointment
          ? format(new Date(row.lastAppointment), "MM/dd/yyyy")
          : "N/A",
    },
    {
      header: "Next Appointment",
      accessor: (row) =>
        row.nextAppointment
          ? format(new Date(row.nextAppointment), "MM/dd/yyyy")
          : "N/A",
    },
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const getDownloadLabel = () => "Download Recall Clients Report";

  const handleDownload = () => {
    if (!recallClients || recallClients.length === 0) {
      alert("No data available to download.");
      return;
    }

    const data = recallClients.map((client) => ({
      "Client Name": client.name,
      Email: client.email || "N/A",
      Phone: client.phone || "N/A",
      "Last Appointment": client.lastAppointment
        ? format(new Date(client.lastAppointment), "MM/dd/yyyy")
        : "N/A",
      "Next Appointment": client.nextAppointment
        ? format(new Date(client.nextAppointment), "MM/dd/yyyy")
        : "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Recall Clients");

    const fileName = `Recall_Clients_Report_${format(
      new Date(),
      "yyyy-MM-dd"
    )}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  // Pagination calculations
  const totalItems = Array.isArray(recallClients) ? recallClients.length : 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData =
    recallClients?.slice(startIndex, startIndex + itemsPerPage) || [];

  return (
    <div className="space-y-4">
      {/* Data Table */}
      <div className="bg-white shadow-sm rounded-sm">
        <Table
          columns={columns}
          data={paginatedData}
          title="Recall Clients Report"
          description="View recall clients and their appointment history"
          showPagination={true}
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalItems}
          onPageChange={handlePageChange}
          actions={[
            {
              label: getDownloadLabel(),
              onClick: handleDownload,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default RecallClientReport;
